<template>
  <div>
    <LoginForm :accessLogin="loginPage" @changeStatus="checkLocalStorage" @switch="loginRegisterSwitch" @byGoogle="googleLogin" @byDB="dbLogin"></LoginForm>

    <div v-if="navPage" class="navigation">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <img src="../assets/logo.png" style="margin-right:12px">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <button class="btn btn-primary" @click="openModal">Add Task</button>
                    </li>
                </ul>

                <button class="btn btn-outline-secondary" @click="doLogout">Logout</button>
            </div>
        </nav>
    </div>
    <ModalAddForm v-model="modalOpen" @reloadTask="loadData"></ModalAddForm>
    <Board 
    v-if="boardPage"
    :backlogLists="tasksOnBacklog"
    :todoLists="tasksOnTodo"
    :doneLists="tasksOnDone"
    :completeLists="tasksOnComplete"
    @updateTask="loadData"
    ></Board>
  </div>
</template>

<script>
import Board from './components/Board'
import ModalAddForm from './components/AddForm'
import LoginForm from './components/LoginForm'
import axios from 'axios'
export default {
    name: "App",
    data() {
        return {
            taskLists: [],
            loginPage: true,
            navPage: null,
            boardPage: null,
            modalOpen: false,
            isGoogle: null,
            url: 'https://gentle-gorge-36916.herokuapp.com'
        }
    },
    components: {
        ModalAddForm,
        Board,
        LoginForm
    },
    computed: {
        tasksOnBacklog() {
            if (this.taskLists) {
                return this.taskLists.filter(el => {
                    return el.category === 'Backlog'
                })
            }
        },
        tasksOnTodo() {
            if (this.taskLists) {
                return this.taskLists.filter(el => {
                    return el.category === 'Todo'
                })
            }
        },
        tasksOnDone() {
            if (this.taskLists) {
                return this.taskLists.filter(el => {
                    return el.category === 'Done'
                })
            }
        },
        tasksOnComplete() {
            if (this.taskLists) {
                return this.taskLists.filter(el => {
                    return el.category === 'Complete'
                })
            }
        }
    },
    methods: {
        openModal() {
            this.modalOpen = !this.modalOpen;
        },
        googleLogin() {
            this.isGoogle = true
        },
        dbLogin() {
            this.isGoogle = false
        },
        doLogout() {
            if (this.isGoogle) {
                this.$gAuth.signOut()
                .then(() => {
                    localStorage.clear();
                    this.checkLocalStorage()
                })
                .catch(error  => {
                    console.log(error)
                })
            }
            else {
                localStorage.clear();
                this.checkLocalStorage()
            }
        },
        loadData() {
            axios({
                url: `${this.url}/tasks/`,
                method: 'get',
                headers: {
                    token: localStorage.token
                }
            })
            .then(response => {
                this.taskLists = response.data.tasks
                console.log(this.taskLists)
                console.log('refresh')
            })
            .catch(err => {
                console.log(err)
            }) 
        },
        checkLocalStorage(){
            if(!localStorage.getItem('token')) {
                this.loginPage = true
                this.navPage = false
                this.boardPage = false
            } else {
                this.loginPage = false
                this.navPage = true
                this.boardPage = true
                this.loadData()
            }
        },
        loginRegisterSwitch() {
            this.loginPage = !this.loginPage
        }
    },
    sockets: {
        connect() {
        console.log('socket connected')
        },
        liveTask(){
        this.loadData()
        console.log('masuk')
        }
    },
    created() {
        this.checkLocalStorage()
    }
};
</script>

<style scoped>
</style>